// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    all_projects_label: 'Wszyscy projekty',
    Cancel: 'Anuluj',
    completeActivityConfirm: 'Trzeba zaznaczyć, że działalność ta jest 100%. Chcesz zmienić swój status na \"zakończone \"? Naciśnij \'OK\', aby zmienić status, lub \"Anuluj\" inaczej.',
    confirmCompleteActivityParents: 'Ukończeniu tego poddziałania będzie nie pozostawiają otwartego te pod jego działania głównego. Chcesz oznaczyć działalność dominująca jak zakończone? Zauważ, że jeśli nie ma bardziej otwartych działań dotyczące projektu zostanie on zaznaczony zakończone, jak również',
};
